import { render, staticRenderFns } from "./LastModifyDocument.vue?vue&type=template&id=f2320df2&scoped=true"
import script from "./LastModifyDocument.vue?vue&type=script&lang=js"
export * from "./LastModifyDocument.vue?vue&type=script&lang=js"
import style0 from "./LastModifyDocument.vue?vue&type=style&index=0&id=f2320df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2320df2",
  null
  
)

export default component.exports